import { useEffect } from "react";
import { FiX, FiDownload } from "react-icons/fi";
import styles from "./ImageLightbox.module.css";

const ImageLightbox = ({ src, onClose }) => {
  useEffect(() => {
    const handler = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, []);

  const handleDownload = () => {
    const a = document.createElement("a");
    a.href = src; a.download = "image.jpg"; a.click();
  };

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.toolbar}>
        <button className={styles.btn} onClick={handleDownload} title="Download"><FiDownload size={20}/></button>
        <button className={styles.btn} onClick={onClose} title="Close"><FiX size={22}/></button>
      </div>
      <img src={src} className={styles.img} onClick={(e) => e.stopPropagation()} alt="preview" />
    </div>
  );
};
export default ImageLightbox;
